export const RECAPTCHA = {
    ENABLE: "1",
    DISABLE: "0"
}

export const SESSION_STATUS = {
    active: "1",
    desactive: "0"
}

export const CODE_APPLICATION = {
    desgravamen: "2",
    rentas: "1",
    vida: "3"
}

export const TYPE_DOCUMENT_CODE = {
    DNI: 1,
    CE: 3,
    PAS: 4
}

export const SIGNATORY_TYPE_INSURED = 1;
export const SIGNATORY_TYPE_CONTRACTOR = 2;
export const SIGNATORY_TYPE_INSURED_ADDITIONAL = 3;